import styled from 'styled-components';
import { InfoRow } from '../Campaigns/Campaigns.styles';

export const DateWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    padding: ${({ theme }) => theme.spacing * 4}px;
    .MuiFormControl-root {
        border: 1px solid rgba(0, 0, 0, 0.23);
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 ${({ theme }) => theme.spacing * 4}px;
    }
    .MuiInput-underline:before, .MuiInput-underline:after {
        content: none;
    }
    .MuiInput-root {
        height: 56px;
    }
    @media screen and (max-width: 690px) {
        grid-template-columns: 1fr;
        grid-row-gap: ${({ theme }) => theme.spacing * 4}px;
    }
`;

export const DateButton = styled.button`
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 ${({ theme }) => theme.spacing * 2}px 0 ${({ theme }) => theme.spacing * 4}px;
    height: 56px;
    background-color: ${({ theme }) => theme.colors.white};
    font-size: 1rem;
    text-align: left;
    color: rgba(0, 0, 0, 0.87);
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    > span {
        color: rgba(0, 0, 0, 0.54);
    }
    .MuiIconButton-root {
        padding: 4px;
    }
`;

export const PaginationWrapper = styled.div`
    display: block;
    width: 960px;
    margin: 0 auto;
    padding: 0;
    border: none;
    .MuiTablePagination-root {
        color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
    }
    .MuiTablePagination-select {
        color: ${({ theme }) => theme.colors.blue};
    }
    @media screen and (max-width: 690px) {
        width: 100%;
        .MuiToolbar-gutters {
            padding: 0;
        }
    }
`;
